module.exports = "/assets/data/b8a4f65042b1fb0713a1be8bf273b3f5-RH6.data.json";